import { Notification } from '@/shared/types/vuetify/snackbar';
import { State } from '../index';
import { NOTIFICATION_MUTATION } from './mutationTypes';

export const notificationMutations = {
  [NOTIFICATION_MUTATION.SHOW_NOTIFICATION]: (
    state: State,
    data: Notification,
  ) => {
    state.notification = { ...data };
  },
  [NOTIFICATION_MUTATION.HIDE_NOTIFICATION]: (state: State) => {
    state.notification.isShow = false;
  },
};
